export default {
    //荷兰语
    DiagnosticReport:'Diagnoseverslag',
    troubleCode:'foutcode',
    time:'tijd',
    PositioningPrompt:'Schakel de locatiefunctie in om lokale prijzen te verkrijgen.',
    FaultCode:'Foutcode',
    AIDiagnosis:'AI-diagnose',
    AIWait:'AI-rapport of wachten op automatische diagnose',
    FailedFaultCode:'Geen toegang tot foutcodeinformatie mogelijk',
    AIError:'AI-analyse mislukt',
    more:'meer',
    StoredCodes:'Bevestig foutcode',
    PendingCodes:'Wachten op foutcode',
    PermanentCodes:'Permanente foutcode',
    Unknown:'onbekend',
    ManufacturerControl:'Gedefinieerd door de automaker',
    continue:'verder',
    // 引导定位
    notlimits:'Toegang tot locatiegegevens kan niet worden verkregen',
    setupSteps:'Instellingsschrijf:',
    openset:'Open de "Instellingen" app',
    findSet:'Zoek de toepassing die je gebruikt',
    clickset:'Klik op "Locatie"',
    selectLimits:'Kies "tijdens gebruik" of "altijd"',
    blackRefresh:'Terug naar toepassing pagina vernieuwen',
    openAppSet:'Klik op "App-beheer" of "Apps"',
    findUseBrowser:'Bekijk de browser die u gebruikt',
    clickAuthority:'Klik op "Beheer rechten"',
    findejurisd:'Zoek de toegang tot "locatie"',
    selectjurisd:'Kies "Toestaan" of "Toestaan bij gebruik"',
    phoneJurisd:'Controleer de locatie-instellingen van de mobiele app:',
    openJurisd:'"Locatie" toegang activeren',
    report:'verslag',
    AI:'AI'
}